module.exports = __webpack_public_path__ + "static/media/image_part_011.53260820.jpg";